/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from 'tss-react/mui';
import { Tokens } from '@jda/lui-common-component-library-mui5';

export const useStyles = makeStyles()((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  emptyScreenRoot: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  searchBarWrap: {
    width: Tokens.spacing['$sp-80'],
  },
  hide: {
    display: 'none'
  },
  mainContent: {
    minHeight: 0,
    flex: 1,
    '& > *': {
      height: '100%'
    }
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    padding: Tokens.spacing['$sp-3']
  },
  topLeftHeaderContainer: {
    display: 'flex',
    textAlign: 'right',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    padding: Tokens.spacing['$sp-2'],
    height: Tokens.spacing['$sp-7-5'],
    color: theme.palette.text.secondary,
    marginRight: Tokens.spacing['$sp-0-25'],
    borderBottomColor: theme.palette.divider,
    borderTopLeftRadius: Tokens.spacing['$sp-1-5'],
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  topRightHeaderContainer: {
    display: 'flex',
    textAlign: 'right',
    alignItems: 'center',
    borderBottomStyle: 'solid',
    padding: Tokens.spacing['$sp-2'],
    height: Tokens.spacing['$sp-7-5'],
    color: theme.palette.text.secondary,
    borderBottomColor: theme.palette.divider,
    borderBottomWidth: Tokens.spacing['$sp-0-25'],
    backgroundColor: theme.palette.background.paper,
    borderTopRightRadius: Tokens.spacing['$sp-1-5'],
  },
  rightContainer: {
    position: 'relative',
    textAlign: 'left',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 0,
    overflowY: 'auto',
    borderBottomRightRadius: Tokens.spacing['$sp-1-25'],
    height: '100%',
    "&.MuiBox-root": {
      padding: Tokens.spacing['$sp-0']
    }
  },
  containerGid: {
    position: 'relative'
  },
  noClients: {
    marginTop: Tokens.spacing['$sp-3-5'],
    padding: Tokens.spacing['$sp-2']
  },
  plusIcon: {
    paddingTop: Tokens.spacing['$sp-1'],
    cursor: 'pointer'
  },
  listItemPaper: {
    textAlign: 'left',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 0,
    overflowY: 'auto',
    marginRight: Tokens.spacing['$sp-0-25'],
    borderBottomLeftRadius: Tokens.spacing['$sp-1-25']
  },
  displayNameHeading: {
    marginLeft: Tokens.spacing['$sp-8-5']
  },
  deleteIcon: {
    marginLeft: 'auto',
  },
  listContainerBorder: {
    borderRight: `1px solid ${theme.palette.divider}`
  },
  searchField: {
    color: theme.palette.text.secondary,
  },
  toolbarPanel: {
    padding: Tokens.spacing['$sp-3'],
  }
}));
